import * as React from 'react';
import PropTypes from 'prop-types';
import tokens from '../../Tokens/tokens';
const { spacing } = tokens;

const BrandIconNoBattery = ({ title, titleId, ...props }) => {
    const sizeArray = Object.entries(spacing.icons);
    const sizeOptions = new Map(sizeArray);
    const displaySize = sizeOptions.get(props.size);
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 48 48'
            fill={props.color && displayColor}
            aria-hidden={!title}
            role={title ? 'img' : null}
            width={props.size && displaySize}
            height={props.size && displaySize}
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <defs>
                <style>{'.NoBattery_svg__cls-2{fill:#002664}'}</style>
            </defs>
            <path d='M18 44a5 5 0 115-5 5 5 0 01-5 5z' fill='#d7153a' />
            <path
                className='NoBattery_svg__cls-2'
                d='M29 4H7a1 1 0 00-1 1v34a1 1 0 001 1h4v-2H8V6h20v32h-3v2h4a1 1 0 001-1V5a1 1 0 00-1-1z'
            />
            <path
                className='NoBattery_svg__cls-2'
                d='M29 0H7a5 5 0 00-5 5v38a5 5 0 005 5h22a5 5 0 005-5V4.87A5 5 0 0029 0zm3 43a3 3 0 01-3 3H7a3 3 0 01-3-3V5a3 3 0 013-3h22a3 3 0 013 3zm14-20h-1v-1a1 1 0 00-2 0v1h-2v-1a1 1 0 00-2 0v1h-1a1 1 0 00-1 1v4a1 1 0 001 1h3v4a4 4 0 01-4 4v-1a1 1 0 00-2 0v4a1 1 0 002 0v-1a6 6 0 006-6v-4h3a1 1 0 001-1v-4a1 1 0 00-1-1zm-1 4h-6v-2h6z'
            />
        </svg>
    );
};

BrandIconNoBattery.propTypes = {
    title: PropTypes.string,
    titleId: PropTypes.string,
    size: PropTypes.oneOf(['lg', 'xl', 'xxl']),
};
BrandIconNoBattery.defaultProps = {
    size: 'xl',
    focusable: false,
};
export default BrandIconNoBattery;
